<script lang="ts">
	import { DownloadIcon } from '$global/assets/icons/DownloadIcon';
	import { LinkButton } from '$global/components/LinkButton';

	interface Props {
		href: string | null | undefined;
		dataCy: string;
		class?: string;
	}

	let { ...props }: Props = $props();
</script>

<LinkButton
	href={props.href}
	class={props.class}
	dataCy={`${props.dataCy}-download-press-release`}
	variant="secondary"
	size="md"
	fullWidth
	newTab
>
	{#snippet leading()}
		<DownloadIcon />
	{/snippet}
	<span class="hidden md:inline-block lg:hidden xl:inline-block">Download</span
	><span>{' '}Press Kit</span>
</LinkButton>
